<template>
     <el-dialog :visible.sync="dialogVisibleflag" title="添加任务" width="700px" :before-close="closeAddTaskDialog">
      <el-form ref="formtask" :model="formtask" :rules="rules" label-width="100px">
        <el-form-item label="任务标题" prop="task_name">
          <el-input v-model="formtask.task_name" show-word-limit />
        </el-form-item>
        <el-form-item label="任务描述">
          <el-input :autosize="{ minRows: 2}" v-model="formtask.task_desc" type="textarea" show-word-limit />
        </el-form-item>
        <el-form-item label="负责人" class="fdg" prop="task_name">
          <!-- <div style="width:400px;"> -->
          <el-select
            v-model="dlgname"
            :remote-method="remoteMethod5"
            :loading="loading"
            filterable
            remote
            reserve-keyword
            placeholder="请输入,支持多选"
            style="width: 100%;"
            @change="changename">
            <el-option
              v-for="(item, index) in useroptions5"
              :key="index"
              :label="item.label+'('+item.value+')'"
              :value="item" />
          </el-select>
          <el-tag
            v-for="(item, index) in username"
            :key="index"
            closable
            style="margin-left: 5px;"
            @close="handleClose1(item)">{{ item.name }}({{ item.username }})</el-tag>
            <!-- </div> -->
        </el-form-item>
        <el-form-item label="顾问" class="fdg" prop="consultant">
          <el-select
            v-model="formtask.consultant"
            :remote-method="remoteMethod2"
            :loading="loading"
            filterable
            remote
            clearable
            reserve-keyword
            placeholder="请输入姓名"
            style="width: 80%;">
            <el-option
              v-for="(item,index) in useroptions2"
              :key="index"
              :label="item.label+'('+item.value+')'"
              :value="item" />
          </el-select>
        </el-form-item>
        <el-form-item label="知会人" class="fdg">
          <el-select
            v-model="dlgname11"
            :remote-method="remoteMethod11"
            :loading="loading"
            filterable
            remote
            reserve-keyword
            placeholder="请输入,支持多选"
            style="width: 80%;"
            @change="changename11">
            <el-option
              v-for="(item,index) in useroptions11"
              :key="index"
              :label="item.label+'('+item.value+')'"
              :value="item" />
          </el-select>
          <el-tag
            v-for="(item, index) in username11"
            :key="index"
            closable
            style="margin-left: 5px;"
            @close="handleClose11(item)">{{ item.name }}({{ item.username }})</el-tag>

        </el-form-item>

        <el-form-item label="担责人" class="fdg" prop="liability_user_id">
          <el-select
            v-model="formtask.liability_user_id"
            :remote-method="remoteMethod4"
            :loading="loading"
            filterable
            remote
            clearable
            reserve-keyword
            placeholder="请输入姓名"
            style="width: 80%;">
            <el-option
              v-for="(item,index) in useroptions4"
              :key="index"
              :label="item.label+'('+item.value+')'"
              :value="item" />
          </el-select>
        </el-form-item>

        <el-form-item label="参与人" class="fdg">
          <el-select
            v-model="dlgname9"
            :remote-method="remoteMethod9"
            :loading="loading"
            filterable
            remote
            reserve-keyword
            placeholder="请输入,支持多选"
            style="width: 80%;"
            @change="changename9">
            <el-option
              v-for="(item,index) in useroptions9"
              :key="index"
              :label="item.label+'('+item.value+')'"
              :value="item" />
          </el-select>
          <el-tag
            v-for="(item, index) in username9"
            :key="index"
            closable
            style="margin-left: 5px;"
            @close="handleClose9(item)">{{ item.name }}({{ item.username }})</el-tag>

        </el-form-item>

        <br >

        <el-form-item label="截止日期" prop="planned_complete_time">
          <el-date-picker
            v-model="formtask.planned_complete_time"
            :picker-options="pickerOptions"
            type="date"
            format="yyyy 年 MM 月 dd 日"
            value-format="yyyy-MM-dd"
            placeholder="选择日期" />
        </el-form-item>

        <el-form-item label="交付件类型" required>
          <el-select v-model="formtask.deliver_type_id" placeholder="请选择" style="width: 220px;">
            <el-option v-for="(item,index) in deliverTypeList" :key="index" :label="item.name" :value="item.id" />
          </el-select>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="closeAddTaskDialog">取 消</el-button>
        <el-button type="primary" @click="addtask('formtask')">确 定</el-button>
      </span>
    </el-dialog>
</template>

<script>
import {
  meetingtask,
  meetingtasks
} from '@/api/seedetails'
export default {
  data() {
    return {
      loading: false,
      formtask: {
        meeting_id: this.$route.query.id
      },
      dlgname: [],
      dlgname11: '',
      dlgname9: '',
      useroptions5: [],
      useroptions4: [],
      pickerOptions: {
        disabledDate: time => {
          // 设置可选择的日期为今天之后的一个月内
          // const curDate = new Date().getTime()
          // 这里算出一个月的毫秒数,
          // 这里使用30的平均值,实际中应根据具体的每个月有多少天计算
          // const day = 10 * 24 * 3600 * 1000
          // const dateRegion = curDate + day
          return time.getTime() < Date.now() - 8.64e7
        }
      },
      username: [],
      useroptions2: [],
      useroptions9: [],
      username9: [],
      username11: [],
      useroptions11: [],
      rules: {
        user_id: [
          {
            required: true,
            message: '请选择负责人',
            trigger: 'change'
          }
        ],
        consultant: [
          {
            required: false,
            message: '请选择顾问',
            trigger: 'change'
          }
        ],
        notify_people_id: [
          {
            required: false,
            message: '请选择知会人',
            trigger: 'change'
          }
        ],
        planned_complete_time: [
          {
            required: true,
            message: '请选择截止日期',
            trigger: 'change'
          }
        ],

        liability_user_id: [
          {
            required: false,
            message: '请选择担责人',
            trigger: 'change'
          }
        ],
        task_name: [
          {
            required: true,
            message: '请输入会议标题',
            trigger: 'blur'
          }
        ]
      }
    }
  },
  props: {
    dialogVisible: {
      default: false,
      type: Boolean
    },
    list: {
      default() { return [] }
    },
    deliverTypeList: {
      default() { return [] }
    }
  },
  computed: {
    dialogVisibleflag: {
      get() {
        return this.dialogVisible
      },
      set() {}
    }
  },
  methods: {
    closeAddTaskDialog() {
      this.$emit('closeAddTaskDialog', false)
    },
    changename9(val) { // 参会人
      const list = {}
      list.name = this.dlgname9.label
      list.username = this.dlgname9.value
      list.id = this.dlgname9.id

      let is = true
      if (this.username9.length > 0) {
        for (let index = 0; index < this.username9.length; index++) {
          const element = this.username9[index]
          if (list.username === element.username) {
            is = false
          }
        }
      } else {
        is = true
      }
      if (is) {
        this.username9.push(list)
      }
    },
    remoteMethod9(query) { // 参与人
      if (query !== '') {
        this.loading = true
        setTimeout(() => {
          this.loading = false
          this.useroptions9 = this.list.filter(item => {
            return item.label.toLowerCase().indexOf(query.toLowerCase()) > -1
          })
        }, 200)
      } else {
        this.options = []
      }
    },
    changename11(val) { // 参会人
      const list = {}
      list.name = this.dlgname11.label
      list.username = this.dlgname11.value
      list.id = this.dlgname11.id

      let is = true
      if (this.username11.length > 0) {
        for (let index = 0; index < this.username11.length; index++) {
          const element = this.username11[index]
          if (list.username === element.username) {
            is = false
          }
        }
      } else {
        is = true
      }
      if (is) {
        this.username11.push(list)
      }
    },
    remoteMethod5(query) {
      if (query !== '') {
        this.loading = true
        setTimeout(() => {
          this.loading = false
          this.useroptions5 = this.list.filter(item => {
            return item.label.toLowerCase().indexOf(query.toLowerCase()) > -1
          })
        }, 200)
      } else {
        this.options = []
      }
    },
    changename(val) {
      // console.log(this.dlgname)
      const list = {
        name: this.dlgname.label,
        username: this.dlgname.value,
        id: this.dlgname.id
      }
      let is = true
      if (this.username.length > 0) {
        for (let index = 0; index < this.username.length; index++) {
          const element = this.username[index]
          if (list.username === element.username) {
            is = false
          }
        }
      } else {
        is = true
      }
      if (is) {
        this.username.push(list)
      }
    },
    handleClose1(tag) {
      this.username.splice(this.username.indexOf(tag), 1)
    },
    remoteMethod2(query) {
      if (query !== '') {
        this.loading = true
        setTimeout(() => {
          this.loading = false
          this.useroptions2 = this.list.filter(item => {
            return item.label.toLowerCase().indexOf(query.toLowerCase()) > -1
          })
        }, 200)
      } else {
        this.options = []
      }
    },
    remoteMethod11(query) { // 知会人
      if (query !== '') {
        this.loading = true
        setTimeout(() => {
          this.loading = false
          this.useroptions11 = this.list.filter(item => {
            return item.label.toLowerCase().indexOf(query.toLowerCase()) > -1
          })
        }, 200)
      } else {
        this.options = []
      }
    },
    handleClose11(tag) {
      this.username11.splice(this.username11.indexOf(tag), 1)
    },
    remoteMethod4(query) {
      if (query !== '') {
        this.loading = true
        setTimeout(() => {
          this.loading = false
          this.useroptions4 = this.list.filter(item => {
            return item.label.toLowerCase().indexOf(query.toLowerCase()) > -1
          })
        }, 200)
      } else {
        this.options = []
      }
    },
    handleClose9(tag) {
      this.username9.splice(this.username9.indexOf(tag), 1)
    },
    gettaskTable(data1) {
      meetingtasks(data1).then(response => {
        if (data1.task_tab === 'all') {
          this.meetingtasklist = response
        }
        this.$parent.meetingtasklists = response.data.tasks || []
      }).catch(err => {
        console.log(err)
      })
    },
    addtask(formName) {
      if (this.formtask.deliver_type_id) {
        console.log('')
      } else {
        this.$message({
          message: '请填写交付件类型',
          type: 'warning'
        })
        return false
      }

      if (this.username.length > 0) {
        const THIs = this
        this.$refs[formName].validate(valid => {
          if (valid) {
            const task_name = THIs.formtask.task_name
            const meeting_id = THIs.$route.query.id

            let liability = ''
            if (THIs.formtask.liability_user_id) {
              liability = {
                user_id: THIs.formtask.liability_user_id.id,
                name: THIs.formtask.liability_user_id.label,
                workcode: THIs.formtask.liability_user_id.value
              }
            }

            let consultant = ''
            if (THIs.formtask.consultant) {
              consultant = {
                user_id: THIs.formtask.consultant.id,
                name: THIs.formtask.consultant.label,
                workcode: THIs.formtask.consultant.value
              }
            }
            // let notify = ''
            if (THIs.formtask.notify_people_id) {
              // notify = {
              //   user_id: THIs.formtask.notify_people_id.id,
              //   name: THIs.formtask.notify_people_id.label,
              //   workcode: THIs.formtask.notify_people_id.value
              // }
            }

            // const leader = {
            //   user_id: THIs.formtask.user_id.id,
            //   name: THIs.formtask.user_id.label,
            //   workcode: THIs.formtask.user_id.value
            // }
            const executor = []
            console.log(this.username)

            for (let index = 0; index < this.username.length; index++) {
              const element = this.username[index]
              const data = {
                user_id: element.id,
                name: element.name,
                workcode: element.username
              }
              executor.push(data)
            }
            // 参会人处理
            const participant = []
            for (let index = 0; index < this.username9.length; index++) {
              const element = this.username9[index]
              const data9 = {
                user_id: element.id,
                name: element.name,
                workcode: element.username
              }
              participant.push(data9)
            }

            const notify = []
            for (let index = 0; index < this.username11.length; index++) {
              const element = this.username11[index]
              const data11 = {
                user_id: element.id,
                name: element.name,
                workcode: element.username
              }
              notify.push(data11)
            }

            const planned_complete_time = THIs.formtask.planned_complete_time
            const data = {
              task_name: task_name,
              meeting_id: meeting_id,
              liability: liability,
              consultant: consultant,
              notify: notify,
              // leader: leader,
              executor: executor,
              planned_complete_time: planned_complete_time,
              deliver_type_id: THIs.formtask.deliver_type_id,
              task_desc: THIs.formtask.task_desc,
              participant: participant// 参会人
            }
            meetingtask(data)
              .then(response => {
                console.log(response)
                this.$message({
                  message: '任务创建成功',
                  type: 'success'
                })
                THIs.formtask = {}
                THIs.dlgname = []
                THIs.dlgname9 = []
                THIs.dlgname10 = []
                THIs.dlgname11 = []
                THIs.dlgname12 = []
                THIs.username = []
                THIs.username9 = []
                THIs.username11 = []
                THIs.useroptions5 = []
                THIs.useroptions4 = []
                THIs.useroptions3 = []
                THIs.useroptions2 = []
                THIs.useroptions1 = []

                THIs.$emit('closeAddTaskDialog', false)
                this.$parent.activeName2 = 'my'
                const data1 = {
                  meeting_id: this.$route.query.id,
                  task_tab: 'my',
                  page: this.page,
                  page_size: this.page_size
                }

                this.gettaskTable(data1)
              })
              .catch(err => {
                console.log(err)
              })
          } else {
            console.log('error submit!!')
            return false
          }
        })
      } else {
        this.$message({
          message: '请选择负责人',
          type: 'warning'
        })
      }
    }

  }
}
</script>

<style>

</style>
